import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "condition-value" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value", "aria-label", "placeholder", "inputmode"]

import StudioSelectField from "../../StudioSelectField.vue";
import type { ConditionValue, ConditionValueSource } from "../types/VisualCondition";

export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionValueEditor',
  props: {
    modelValue: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const sources: { value: ConditionValueSource; label: string }[] = [
  { value: "player", label: "玩家自身变量" }, { value: "character", label: "当前角色变量" },
  { value: "level", label: "关卡变量" }, { value: "number", label: "固定数字" },
  { value: "text", label: "固定文本" }, { value: "boolean", label: "固定布尔值" },
];
function changeSource(event: Event) {
  const source = (event.target as HTMLSelectElement).value as ConditionValueSource;
  emit("update:modelValue", { source, value: source === "number" ? "0" : source === "boolean" ? "true" : "" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createElementVNode("legend", null, _toDisplayString(__props.label), 1),
    _createVNode(StudioSelectField, {
      value: __props.modelValue.source,
      "aria-label": `${__props.label}来源`,
      onChange: changeSource
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sources, (source) => {
          return _createElementVNode("option", {
            key: source.value,
            value: source.value
          }, _toDisplayString(source.label), 9, _hoisted_2)
        }), 64))
      ]),
      _: 1
    }, 8, ["value", "aria-label"]),
    (__props.modelValue.source === 'boolean')
      ? (_openBlock(), _createBlock(StudioSelectField, {
          key: 0,
          value: __props.modelValue.value,
          "aria-label": `${__props.label}布尔值`,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', { ...__props.modelValue, value: ($event.target as HTMLSelectElement).value })))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("option", { value: "true" }, "真", -1),
            _createElementVNode("option", { value: "false" }, "假", -1)
          ]))]),
          _: 1
        }, 8, ["value", "aria-label"]))
      : (_openBlock(), _createElementBlock("input", {
          key: 1,
          value: __props.modelValue.value,
          "aria-label": `${__props.label}${['player', 'character', 'level'].includes(__props.modelValue.source) ? '变量名' : '固定值'}`,
          placeholder: ['player', 'character', 'level'].includes(__props.modelValue.source) ? '填写变量名' : '填写固定值',
          inputmode: __props.modelValue.source === 'number' ? 'decimal' : 'text',
          onInput: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', { ...__props.modelValue, value: ($event.target as HTMLInputElement).value })))
        }, null, 40, _hoisted_3))
  ]))
}
}

})